export default {
  effects: {
    captions: {
      blur: 'Flouter',
      crop: 'Recadrer',
      enhance: 'Effets',
      flip: 'Retourner',
      grayscale: 'Noir et blanc',
      invert: 'Inverser',
      mirror: 'Mirroir',
      rotate: 'Tourner',
      sharp: 'Netteté',
    },
    apply: 'Appliquer',
  },
}
